import { render, staticRenderFns } from "./NewGallery.vue?vue&type=template&id=bcf0c708&scoped=true&"
import script from "./NewGallery.vue?vue&type=script&lang=js&"
export * from "./NewGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf0c708",
  null
  
)

export default component.exports